<div class="container-header" [ngClass]="{ 'container-header-padding': !tabs || tabs.length === 0 }">
  <div class="d-flex">
    <div>
      <i class="{{icon}}"></i>
      <h1>{{title}}</h1>
    </div>
    <div class="header-button">
      <ng-content></ng-content>
      <ng-container [ngTemplateOutlet]="headerRef"></ng-container>
      @for (button of buttons; track button) {
        <button #button type="submit" class="btn btn--primary" [ngClass]="{'btn--outline-grey-color': button.isSecondary}" (click)="button.action($event)">{{ button.text }}</button>
      }
    </div>
  </div>
  @if (backUrl) {
    <div>
      <a [routerLink]="backUrl.url" [queryParams]="backUrl.params" class="link" [translate]="'action.back_to_list'"></a>
    </div>
  }
  @if (tabs && tabs.length > 0) {
    <nav>
      <ul class="tab__ctn">
        @for (tab of tabs; track tab) {
          <li>
            <a [routerLink]="(url$ | async) + tab.link" [translate]="tab.name" [routerLinkActive]="['active']"></a>
          </li>
        }
      </ul>
    </nav>
  }
  <hr/>
</div>
